import axios, { type AxiosInstance } from "axios";
import authStorage from "../../storage/authStorage";

const { REACT_APP_SERVER_HOST_INTERNAL: SERVER_HOST, REACT_APP_LOCAL_API } = process.env;

// URL padrão de produção (usada quando variáveis de ambiente não estão definidas)
const DEFAULT_API = "https://api.supreq.codilo.net.br";

const stripQuotes = (s: string) => s.replace(/^"(.*)"$/, "$1");

// Resolução unificada: REACT_APP_LOCAL_API (dev local) → SERVER_HOST (produção) → DEFAULT_API
const getBaseURL = () => {
  if (REACT_APP_LOCAL_API) return stripQuotes(String(REACT_APP_LOCAL_API));
  if (SERVER_HOST) return stripQuotes(String(SERVER_HOST));
  return DEFAULT_API;
};

const apiInternal = axios.create({
  baseURL: getBaseURL(),
});

// apiLocal aponta para o mesmo backend — alias mantido para compatibilidade com imports existentes
const apiLocal = apiInternal;

/** Registra Bearer + tratamento de 401 (logout) — necessário também no apiLocal para /buscar-fonte etc. */
let isLoggingOut = false;
function attachAuthInterceptors(client: AxiosInstance): void {
  client.interceptors.request.use(
    async (config) => {
      const token = await authStorage.get();
      if (config.headers) {
        config.headers.Authorization = `Bearer ${token || ""}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  client.interceptors.response.use(
    (response) => response,
    (error) => {
      const originalRequest = error.config;
      const isUnauthorized = error.response?.status === 401;
      const isForbidden = error.response?.status === 403;
      const isAuthEndpoint = originalRequest?.url?.includes("/auth");

      if ((isUnauthorized || isForbidden) && !isAuthEndpoint && !isLoggingOut) {
        isLoggingOut = true;
        authStorage.remove();
        window.dispatchEvent(new CustomEvent("auth:logout-required"));
        setTimeout(() => {
          isLoggingOut = false;
        }, 1000);
      }
      return Promise.reject(error);
    }
  );
}

attachAuthInterceptors(apiInternal);

export default apiInternal;
export { apiLocal };
